import { apiInstance } from '../config/apiInstance';

export const putData = async(url:string, data:any): Promise<any> => {
    const response = await apiInstance.put( url, data);
    return response;
}